import { fetchEndpoint } from "../network";

/**
 * 内容管理 - 文章管理
 */

export default {
  // 列表
  list(params) {
    return fetchEndpoint("/content/list", "GET", params);
  },
  // 条数
  nums(params) {
    return fetchEndpoint("/content/nums", "GET", params);
  },
  // 查重
  checkSame(params) {
    return fetchEndpoint("/content/same", "GET", params);
  },
  remove(params) {
    return fetchEndpoint("/content/article/delete", "POST", params);
  },
};
